import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Vineyard from "@/pages/Vineyard";

function App() {
  return (
    <div className="App grain-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/vineyard" element={<Vineyard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#150c2b",
            border: "1px solid #3a2166",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
